<i18n locale="en">
{
  "subtitle": "Try changing your search term"
}
</i18n>

<template>
  <SelectorCard class="no-data-card" disabled>
    <OwnStack class="pa-4" spacing="1">
      <h3 class="text-subtitle-1" v-text="title"></h3>
      <p
        class="text-paragraph text-color-secondary"
        v-text="$t('subtitle')"
      ></p>
    </OwnStack>
  </SelectorCard>
</template>

<script>
import { OwnStack } from '@/ui'

import SelectorCard from './SelectorCard.vue'

export default {
  name: 'NoDataCard',
  components: { OwnStack, SelectorCard },
  props: {
    /** Title for the card */
    title: { type: String, required: true },
  },
}
</script>

<style lang="scss" scoped>
.no-data-card {
  pointer-events: none;
  cursor: default;
}
</style>
